import React, { useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

// import { loadCheckout } from "@tiltbike/razorpay-checkout-js";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import moment from "moment";
import { CardHeader, Divider } from "@mui/material";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import UserService from "../../services/UserService";
import TopBar from "../TopBar";
import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import PaymentService from "../../services/PaymentService";
import StateService from "../../services/StateService";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Paper from "@mui/material/Paper";
import config from "../../config";
import firebase from "../../firebase";
import HelpCTA from "../HelpCTA";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

let mhState = {
  code: "MH",
  language: { name_en: "marathi", code: "mr", name_vernacular: "मराठी" },
  name_en: "maharashtra",
  name_vernacular: "महाराष्ट्र",
};
const useStyles = makeStyles((theme) => ({
  main: {
    minHeight: window.innerHeight,
  },
  input: {
    // minWidth: "20em",
  },
  signupCard: {
    // minWidth:'50vw'
    minHeight: "80vh",
  },
  infoContainer: {
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    // minHeight: "20vh",
  },
  infoCardWrapper: {
    flex: "0 0 auto",
  },
  infoCard: {
    background: "#FAEEEE",
  },

  signupContainer: {
    // minHeight: "95vh",
  },
  signupFormContainer: {
    minHeight: "30vh",
  },
  tnc: {
    marginBottom: theme.spacing(1),
  },
  errorMessage: {
    color: "red",
  },
  membershipDetailsCard: {
    background: "#DFBE56",
  },
  discountContainer: {},
  paymentCardWrapper: {},
  billSummaryRow: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  paymentSuccessfulCard: {
    background: "#E6F2EC",
    minHeight: "80vh",
  },
}));

export default function Signup(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);

  const skipSignup = false;
  const skipPayment = false;

  let history = useHistory();
  const [rememberMe, setRememberMe] = React.useState(true);
  const [name, setName] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [mode, setMode] = React.useState("");

  const [signupFailureMessage, setSignupFailureMessage] = React.useState("");
  const [state, setState] = React.useState("");
  const [userState, setUserState] = React.useState(mhState);
  let [states, setStates] = React.useState(props.states || []);

  let params = useParams();

  let userStateName = userState ? userState.name_en : "maharashtra";
  useEffect(() => {
    if (props.userState) {
      setUserState(props.userState);
    }
    if (props && props.states && props.states.length > 0) {
      setStates(props.states);
    }
    UserService.checkPremium() ? history.push("/dashboard") : void 0;

    console.log(params);
    if (params && params.mode !== "") {
      if (params.mobile !== "") {
        setMode(params.mode);
        setMobile(params.mobile);

        if (params.mode === "pay") {
          UserService.saveUser(name, params.mobile, userStateName, true);
          handleNext();
        }
      }
    }
  }, [props.userState]);

  const handleChangeRememberMe = (event) => {
    setRememberMe(!rememberMe);
  };

  const handleChangeName = (event) => {
    setName(event.target.value);
  };

  const handleChangeMobile = (event) => {
    setMobile(event.target.value);
  };

  const handleChangeState = (event) => {
    setState(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    firebase.analytics().logEvent("signup_userinfo_submitted", {
      state_name: userStateName,
      mobile,
    });
    if (skipSignup === true) {
      handleNext();
      return;
    }
    if (mode === "" || mode === undefined) {
      UserService.signup(name, mobile, userState)
        .then(async (response) => {
          if (response && response.data) {
            if (response.data.result === "success") {
              setSignupFailureMessage("");

              UserService.saveUser(name, mobile, userStateName, true);
              console.log("signup successful");
              firebase.analytics().logEvent("signup_success", {
                mobile: mobile,
                stateName: userState.name_en.toLowerCase(),
              });

              handleNext();
            } else {
              if (response.data.data) {
                UserService.saveUser(name, mobile, userStateName, true, false);
                console.log("signup successful");
                firebase.analytics().logEvent("free_signup_login_redirection", {
                  mobile: mobile,
                  stateName: userState.name_en.toLowerCase(),
                });
                history.push("/dashboard");
              } else {
                if (response.data.message) {
                  setSignupFailureMessage(response.data.message);
                }
              }
            }
          }
        })
        .catch((error) => {
          setSignupFailureMessage(`SOMETHING_WENT_WRONG`);
        });
    } else if (mode === "pay") {
      // handleNext();
    } else {
    }
  };
  const handleReset = () => {
    setActiveStep(0);
  };

  function getSteps() {
    return [
      messages["signup.profileSetupStepper"][language],
      messages["signup.paymentStepper"][language],
    ];
  }

  const steps = getSteps();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());

  const isStepOptional = (step) => {
    return false;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const payButtonHandler = () => {
    if (skipPayment === true) {
      handleNext();
      return;
    }
    let createOrder = async () => {
      PaymentService.createOrder(mobile, props.paymentPackage)
        .then(async (response) => {
          if (response && response.data && response.data.status === "created") {
            if (response.data.order_id) {
              let order_id = response.data.order_id;
              let paymentOptions = {
                key: config.razerpayKeyId, // Enter the Key ID generated from the Dashboard
                amount: response.data.amount_due,
                currency: "INR",
                name: "AgroStar",
                description: "AgroStar Gold Service Subscription",
                image: "https://gold.agrostar.in/gold.png",
                order_id: response.data.order_id,
                handler: function (response) {
                  PaymentService.verifyPayment(
                    mobile,
                    order_id,
                    response.razorpay_order_id,
                    response.razorpay_payment_id,
                    response.razorpay_signature
                  )
                    .then((response) => {
                      if (response && response.data) {
                        if (response.data.result === "success") {
                          console.log("user subscribed successfully");
                          firebase.analytics().logEvent("payment_success", {
                            mobile: mobile,
                            stateName: userState.name_en.toLowerCase(),
                          });
                          localStorage.setItem("premium", true);
                          handleNext();
                          window.setTimeout(() => {
                            history.push("/dashboard");
                          }, 5000);
                        }
                      }
                    })
                    .catch((reason) => () => {});
                },
                prefill: {
                  name: name,
                  contact: mobile,
                  email: `namastegold@agrostar.in`,
                  method: `upi`,
                },
                theme: {
                  color: "#9D2123",
                },
              };

              // const razerpay = await loadCheckout(paymentOptions);
              //
              // razerpay.open();
            }
          }
        })
        .catch((error) => {});
    };

    createOrder();
  };

  // const theme = useTheme();
  const theme = useTheme();
  const isLessThanSmall = useMediaQuery(theme.breakpoints.down('md'));
  const fullScreen = isLessThanSmall;

  return <>
    <div className={classes.main}>
      <TopBar location={"join"} />
      {props && props.paymentPackage && (
        <div className={classes.signupContainer}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
          >
            <Grid item xs={12} sm={8} md={5} lg={3}>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};
                  if (isStepOptional(index)) {
                    labelProps.optional = (
                      <Typography variant="caption">
                        {messages["signup.optional"][language]}
                      </Typography>
                    );
                  }
                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </Grid>
          </Grid>
          {activeStep === 0 && (
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="flex-start"
            >
              <Grid item xs={12} sm={8} md={5} lg={3}>
                <Paper elevation={0} className={classes.signupCard}>
                  <form onSubmit={handleSubmit}>
                    <CardContent>
                      <div className={classes.infoContainer}>
                        <Grid
                          container
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="flex-start"
                          wrap={"nowrap"}
                          spacing={2}
                        >
                          <Grid
                            item
                            xs={8}
                            className={classes.infoCardWrapper}
                          >
                            <Card className={classes.infoCard}>
                              <CardHeader
                                title={
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                  >
                                    <Grid item>
                                      <Typography variant={"h6"}>
                                        01
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                }
                                subheader={
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                  >
                                    <Grid item>
                                      <Typography variant={"body2"}>
                                        {messages["landing.msg1"][language]}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                }
                              ></CardHeader>
                            </Card>
                          </Grid>
                          <Grid
                            item
                            xs={8}
                            className={classes.infoCardWrapper}
                          >
                            <Card className={classes.infoCard}>
                              <CardHeader
                                title={
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                  >
                                    <Grid item>
                                      <Typography variant={"h6"}>
                                        02
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                }
                                subheader={
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                  >
                                    <Grid item>
                                      <Typography variant={"body2"}>
                                        {messages["landing.msg2"][language]}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                }
                              ></CardHeader>
                            </Card>
                          </Grid>
                          <Grid
                            item
                            xs={8}
                            className={classes.infoCardWrapper}
                          >
                            <Card className={classes.infoCard}>
                              <CardHeader
                                title={
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                  >
                                    <Grid item>
                                      <Typography variant={"h6"}>
                                        03
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                }
                                subheader={
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                  >
                                    <Grid item>
                                      <Typography variant={"body2"}>
                                        {messages["landing.msg3"][language]}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                }
                              ></CardHeader>
                            </Card>
                          </Grid>
                          <Grid
                            item
                            xs={8}
                            className={classes.infoCardWrapper}
                          >
                            <Card className={classes.infoCard}>
                              <CardHeader
                                title={
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                  >
                                    <Grid item>
                                      <Typography variant={"h6"}>
                                        04
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                }
                                subheader={
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                  >
                                    <Grid item>
                                      <Typography variant={"body2"}>
                                        {messages["landing.msg4"][language]}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                }
                              ></CardHeader>
                            </Card>
                          </Grid>
                          <Grid
                            item
                            xs={8}
                            className={classes.infoCardWrapper}
                          >
                            <Card className={classes.infoCard}>
                              <CardHeader
                                title={
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                  >
                                    <Grid item>
                                      <Typography variant={"h6"}>
                                        05
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                }
                                subheader={
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                  >
                                    <Grid item>
                                      <Typography variant={"body2"}>
                                        {messages["landing.msg5"][language]}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                }
                              ></CardHeader>
                            </Card>
                          </Grid>
                        </Grid>
                      </div>

                      <br />
                      <br />

                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid item>
                          <Typography variant={"h6"}>
                            {messages["signup.classWaiting"][language]}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid item>
                          <Typography variant={"body2"}>
                            {messages["free.createProfile"][language]}
                          </Typography>
                        </Grid>
                      </Grid>
                      <br />
                      <Grid
                        className={classes.signupFormContainer}
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="flex-start"
                        spacing={2}
                      >
                        <Grid item xs={12}>
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="flex-start"
                          >
                            <Grid item xs={12}>
                              <TextField
                                id="name"
                                className={classes.input}
                                onChange={handleChangeName}
                                value={name}
                                required={true}
                                variant={"outlined"}
                                inputProps={{ type: "text" }}
                                fullWidth
                                label={messages["login.form.name"][language]}
                              />
                            </Grid>
                          </Grid>

                          <br />
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="flex-start"
                          >
                            <Grid item xs={12}>
                              <TextField
                                id="mobile"
                                className={classes.input}
                                onChange={handleChangeMobile}
                                value={mobile}
                                variant={"outlined"}
                                required={true}
                                inputProps={{
                                  type: "tel",
                                  minLength: "10",
                                  maxLength: "10",
                                }}
                                fullWidth
                                label={
                                  messages["login.form.mobile"][language]
                                }
                              />
                            </Grid>
                          </Grid>

                          <>
                            <br />
                            <Grid
                              container
                              direction="row"
                              justifyContent="center"
                              alignItems="flex-start"
                            >
                              <Grid item xs={12}>
                                <FormControl
                                  fullWidth
                                  required
                                  variant="outlined"
                                >
                                  <InputLabel htmlFor="select-state">
                                    {" "}
                                    {messages["login.form.state"][language]}
                                  </InputLabel>
                                  <Select
                                    native={true}
                                    label={
                                      messages["login.form.state"][language]
                                    }
                                    value={userState.name_en}
                                    inputProps={{
                                      name: "state",
                                      id: "select-state",
                                    }}
                                    onChange={(event) => {
                                      let newUserState =
                                        StateService.getStateByName(
                                          props.states,
                                          event.target.value.toLowerCase()
                                        );

                                      setUserState(newUserState);
                                      userStateName = newUserState.name_en;
                                    }}
                                  >
                                    {props.states.map((state, index) => {
                                      return (
                                        <option value={state.name_en}>
                                          {state.name_vernacular}
                                        </option>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </Grid>
                            </Grid>
                          </>
                        </Grid>
                        {signupFailureMessage && signupFailureMessage !== "" && (
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="flex-start"
                          >
                            <Grid item>
                              {signupFailureMessage ===
                                "DUPLICATE_MOBILE" && (
                                <Typography
                                  variant={"body1"}
                                  className={classes.errorMessage}
                                >
                                  {messages["signup.userExists"][language]}
                                  <br />
                                  <a href={"/login"}>
                                    {messages["login.login"][language]}
                                  </a>
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                        )}
                      </Grid>

                      <br />
                      <br />
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="flex-start"
                        className={classes.tnc}
                      >
                        <Grid item>
                          <Typography variant={"caption"}>
                            {messages["signup.tncStart"][language]}{" "}
                            <a href={messages["footer.tncLinks"][language]}>
                              {messages["signup.tncText"][language]}
                            </a>
                            {messages["signup.tncEnd"][language]}{" "}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid item>
                          <Button
                            variant={"contained"}
                            color={"primary"}
                            type={"submit"}
                            size={"large"}
                            endIcon={<ArrowForwardIcon />}
                          >
                            {messages["signup.otpDialogContinue"][language]}
                          </Button>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </form>
                </Paper>
              </Grid>
            </Grid>
          )}
          {activeStep === 1 && (
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="flex-start"
            >
              <Grid item xs={12} sm={8} md={5} lg={3}>
                <Card className={classes.signupCard}>
                  <CardContent>
                    {userState &&
                      userState.name_en &&
                      (userState.name_en.toLowerCase() === `maharashtra` ||
                        userState.name_en.toLowerCase() === `gujarat` ||
                        userState.name_en.toLowerCase() === `rajasthan` ||
                        userState.name_en.toLowerCase() ===
                          `madhya pradesh` ||
                        userState.name_en.toLowerCase() ===
                          `uttar pradesh`) && (
                        <>
                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            spacing={2}
                          >
                            <Grid
                              item
                              xs={12}
                              className={classes.paymentCardWrapper}
                            >
                              <Card className={classes.membershipDetailsCard}>
                                <CardContent>
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <img
                                        src={`/icons/gold-logo-grey.png`}
                                        alt=""
                                        height={"25"}
                                      />
                                    </Grid>
                                    <Grid item>
                                      <Typography variant={"h6"}>
                                        {
                                          messages[
                                            "signup.membershipDetails"
                                          ][language]
                                        }
                                      </Typography>
                                    </Grid>
                                  </Grid>

                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{ marginTop: "5px" }}
                                  >
                                    <Grid item>
                                      <Typography variant={"body2"}>
                                        {
                                          messages["signup.duration"][
                                            language
                                          ]
                                        }
                                      </Typography>
                                    </Grid>
                                    <Grid item>
                                      <Typography variant={"body2"}>
                                        {props.paymentPackage.duration / 30}{" "}
                                        {messages["signup.months"][language]}
                                      </Typography>
                                    </Grid>
                                  </Grid>

                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{ marginTop: "5px" }}
                                  >
                                    <Grid item>
                                      <Typography variant={"body2"}>
                                        {
                                          messages["signup.validTill"][
                                            language
                                          ]
                                        }
                                      </Typography>
                                    </Grid>
                                    <Grid item>
                                      <Typography variant={"body2"}>
                                        {moment()
                                          .add(
                                            props.paymentPackage.duration,
                                            "d"
                                          )
                                          .format("DD-MMM-YYYY")}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </CardContent>
                              </Card>
                            </Grid>
                          </Grid>

                          <br />

                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={2}
                            className={classes.billSummaryTitle}
                          >
                            <Grid item>
                              <Typography variant={"h6"}>
                                <b>
                                  {messages["signup.billSummary"][language]}
                                </b>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            className={classes.billSummaryRow}
                          >
                            <Grid item>
                              <Typography variant={"body2"}>
                                {messages["signup.subTotal"][language]}
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography variant={"body2"}>
                                ₹{" "}
                                {new Intl.NumberFormat("en-IN", {
                                  maximumSignificantDigits: 4,
                                }).format(props.paymentPackage.amount)}{" "}
                                /-
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            className={classes.billSummaryRow}
                          >
                            <Grid item>
                              <Typography
                                variant={"body2"}
                                color={"secondary"}
                              >
                                {messages["signup.discount"][language]}
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography
                                variant={"body2"}
                                color={"secondary"}
                              >
                                - ₹{" "}
                                {new Intl.NumberFormat("en-IN", {
                                  maximumSignificantDigits: 4,
                                }).format(props.paymentPackage.discount)}{" "}
                                /-
                              </Typography>
                            </Grid>
                          </Grid>

                          <Divider />

                          <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            className={classes.billSummaryRow}
                          >
                            <Grid item>
                              <Typography variant={"body2"}>
                                <b>{messages["signup.total"][language]}</b>
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography variant={"body2"}>
                                <b>
                                  ₹{" "}
                                  {new Intl.NumberFormat("en-IN", {
                                    maximumSignificantDigits: 4,
                                  }).format(
                                    props.paymentPackage.amount_after_discount
                                  )}{" "}
                                  /-
                                </b>
                                {/* {messages["landing.offerNew"][language]} */}
                              </Typography>
                            </Grid>
                          </Grid>

                          <br />
                          <br />
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Grid item>
                              <Button
                                variant={"contained"}
                                color={"primary"}
                                type={"submit"}
                                size={"large"}
                                onClick={payButtonHandler}
                                endIcon={<ArrowForwardIcon />}
                              >
                                {messages["signup.payAndContinue"][language]}
                              </Button>
                            </Grid>
                          </Grid>
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />

                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                          >
                            {" "}
                            <HelpCTA
                              helpText={
                                messages["help.cta.question.payment"][
                                  language
                                ]
                              }
                              style={{ marginTop: "16px" }}
                              page="payment"
                              mobile={mobile}
                              userState={userStateName}
                              section={"need_help"}
                            />
                          </Grid>
                        </>
                      )}
                    {userState === null && (
                      <>
                        <Grid
                          container
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="flex-start"
                          spacing={2}
                        >
                          <Grid item xs={12}>
                            <CardContent>
                              <Typography variant={"body2"}>
                                {messages["signup.comingSoon"][language]}
                              </Typography>
                            </CardContent>
                          </Grid>
                        </Grid>
                      </>
                    )}
                    {(userState &&
                      userState.name_en &&
                      userState.name_en.toLowerCase() !== `maharashtra` &&
                      userState.name_en.toLowerCase() !== `gujarat` &&
                      userState.name_en.toLowerCase() !== `rajasthan`) ||
                      userState.name_en.toLowerCase() === `madhya pradesh` ||
                      (userState.name_en.toLowerCase() ===
                        `uttar pradesh` && (
                        <>
                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            spacing={2}
                          >
                            <Grid item xs={12}>
                              <Card>
                                <CardContent>
                                  <Typography variant={"body2"}>
                                    {messages["signup.comingSoon"][language]}
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Grid>
                          </Grid>
                        </>
                      ))}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
          {activeStep === 2 && (
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} sm={8} md={5} lg={3}>
                <Card className={classes.paymentSuccessfulCard}>
                  <br />
                  <br />
                  <CardContent>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <img src={"icons/check.svg"} height={"73px"} />
                      </Grid>
                    </Grid>

                    <br />
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography variant={"h6"} color={"secondary"}>
                          <b>{messages["signup.paymentSuccess"][language]}</b>
                        </Typography>
                      </Grid>
                    </Grid>
                    <br />
                    <br />
                    <br />
                    <br />

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <img
                          src={"../../icons/namaste.png"}
                          alt=""
                          style={{ width: "40px", height: "40px" }}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography variant={"h6"}>
                          <b>{messages["signup.welcome"][language]}</b>
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography variant={"subtitle1"}>
                          {messages["signup.addedInFamily"][language]}
                        </Typography>
                      </Grid>
                    </Grid>

                    <br />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </div>
      )}
    </div>
  </>;
}
